<div [class.ant-menu-item-group-title]="!isMenuInsideDropDown" [class.ant-dropdown-menu-item-group-title]="isMenuInsideDropDown" #titleElement>
  <ng-container *nzStringTemplateOutlet="nzTitle">{{ nzTitle }}</ng-container>
  <ng-content select="[title]" *ngIf="!nzTitle"></ng-content>
</div>
<ng-content></ng-content>
